import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { defineMessages, useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import qs from 'qs'
import { useOidc } from '@axa-fr/react-oidc'
import { MikeButton } from '@mike/mike-shared-frontend'
import LandingLayout from './LandingLayout'
import { LOGGING_OUT } from '../mike-login'
import { INVITATION_VERSION } from '../../helpers/search-params.const'
import { INVITATION_TOKEN } from '../InvitationProvider/InvitationProvider'
import { hasSessionEnded } from '../../actions/sessionBridge'

type StringMap = Record<string, string>

const localMessages = defineMessages({
  button: {
    id: 'screens.loginScreen.button'
  },
  unsureHint: {
    id: 'screens.loginScreen.unsureHint'
  },
  unsureLink: {
    id: 'screens.loginScreen.unsureLink'
  }
})

const StyledNotes = styled(Typography)({
  marginTop: 20,
  display: 'inline-block'
})

const LandingPage = () => {
  const { login } = useOidc()
  const intl = useIntl()

  const { search, pathname } = useLocation()

  const pathAndSearch = search.length > 1 ? pathname + search : pathname

  useEffect(() => {
    const loggingOut = sessionStorage.getItem(LOGGING_OUT)
    sessionStorage.removeItem(LOGGING_OUT)
    if (loggingOut !== 'true' && !hasSessionEnded()) {
      let extras: StringMap = {
        prompt: 'none',
        noTenant: search.includes(INVITATION_VERSION).toString()
      }

      if (search) {
        const parameters = qs.parse(search.replace('?', '')) || {}
        if (parameters.tenantId) {
          extras = {
            ...extras,
            tenantId: parameters.tenantId.toString(),
            noTenant: search.includes(INVITATION_VERSION).toString()
          }
        }
      }

      const invitationToken = localStorage.getItem(INVITATION_TOKEN)
      if (invitationToken?.includes(INVITATION_VERSION)) {
        extras = {
          ...extras,
          noTenant: 'true'
        }
      }

      login(pathAndSearch, extras)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LandingLayout>
      <>
        <Grid item container justifyContent="center" xs={12}>
          <MikeButton
            color="secondary"
            variant="contained"
            onClick={() => {
              login(pathAndSearch)
            }}
          >
            {intl.formatMessage(localMessages.button)}
          </MikeButton>
        </Grid>

        <Grid item xs={12}>
          <StyledNotes variant="caption">
            <label>{intl.formatMessage(localMessages.unsureHint)}</label>&nbsp;
            <a href="mailto:mike@dhigroup.com&Subject=Access%20to%20DHI%20Cloud%20Bridge">
              {intl.formatMessage(localMessages.unsureLink)}
            </a>
            .
          </StyledNotes>
        </Grid>
      </>
    </LandingLayout>
  )
}

export default connect()(LandingPage)
